export default __webpack_public_path__ + "static/oxen-4d86c2ce38bd80582881c8135edc6525.jpg";